import { useState, useEffect } from "react";
import {
  applyFilters,
  filterByModel,
  handleResetFilters,
} from "../../../Utils/FiltersManager";
import { toggleSort, applySort } from "../../../Utils/SortManager";
import Pagination, { useRedirectCurrentPage } from "../../../Utils/Pagination";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "./LotsTable.css";
import { setEnvironmentColors } from "../../../Utils/EnvironnementColor";
import { parseCustomDate } from "../../../Utils/DateManager";
import {
  renderHeaderRow,
  renderFilterRow,
  renderDataRow,
} from "../../../Utils/ColumnManager";
import "bootstrap/dist/css/bootstrap.min.css";
import DateFilterModal from "../../../Utils/Modals/DateFilterModal";
import { useLotsState } from "../../../Utils/FiltersManager";
import RelaunchInstance from "../../../UtilsAdmin/AdmModals/RelaunchInstance";

const LotsTableComponent = ({
  data = [],
  setData = () => {},
  modelId,
  clientId,
  page,
  config,
  filter,
  setFilter,
  configKey,
  modelInstanceStatuses
  
}) => {
  const [filteredData, setFilteredData] = useState([]);
  const itemsPerPage = 10;
  const navigate = useNavigate();
  const [colorFilter, setcolorFilter] = useState("#235073");
  const [colorFilterAction, setcolorFilterAction] = useState("#ffffff");
  const { t } = useTranslation();
  
  const [isDateFilterVisible, setIsDateFilterVisible] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedInstance, setSelectedInstance] = useState(null);
  const {
    currentPage,
    setCurrentPage,
    sortField,
    setSortField,
    sortOrder,
    setSortOrder,
    dateRangeFilter,
    setDateRangeFilter,
  } = useLotsState();

  const handleCloseModal = () => {
    setShowModal(false);
  };

  
  const handleRelaunchClick = (item) => {
    setSelectedInstance(item);
    setShowModal(true);
  };

  // Bascule la visibilité du filtre par date
  const toggleDateFilterVisibility = () => {
    setIsDateFilterVisible(!isDateFilterVisible);
  };

  // Gère le tri sur un champ donné
  const handleSort = (field) => {
    toggleSort(field, sortField, setSortField, sortOrder, setSortOrder);
  };

  // Définit les couleurs d’environnement à l’affichage du composant
  useEffect(() => {
    setEnvironmentColors([
      [setcolorFilter, "colorFilter"],
      [setcolorFilterAction, "colorFilterAction"],
    ]);
  }, []);

  // Applique les filtres et met à jour les données filtrées
  useEffect(() => {
    const dataAfterFilters = applyFilters(
      data,
      filter,
      dateRangeFilter,
      parseCustomDate
    );
    const dataAfterModelFilter = filterByModel(dataAfterFilters, filter);
    setFilteredData(dataAfterModelFilter);
  }, [data, filter, dateRangeFilter, parseCustomDate]);

  useRedirectCurrentPage(
    filteredData,
    itemsPerPage,
    currentPage,
    setCurrentPage
  );

  // Extraction de valeurs uniques depuis des chemins imbriqués
  const getUniqueValuesByPath = (data, path) => {
    const getNestedValue = (obj, path) =>
      path.split(".").reduce((acc, part) => acc && acc[part], obj);

    return [
      ...new Set(
        data.map((item) => getNestedValue(item, path)).filter(Boolean)
      ),
    ];
  };

  // Générer `uniqueValuesByKey` automatiquement
  const generateUniqueValuesByKey = (data, columns) => {
    return columns.reduce((acc, col) => {
      if (col.key) {
        acc[col.key] = getUniqueValuesByPath(data, col.key);
      }
      return acc;
    }, {});
  };

  const uniqueValuesByKey = generateUniqueValuesByKey(data, config);

  const context = {
    data,
    colorFilter,
    colorFilterAction,
    sortField,
    sortOrder,
    handleSort,
    handleResetFilters,
    setFilter,
    filter,
    t,
    tableId: "Lots",
    uniqueValuesByKey,
    page,
    modelId,
    handleRelaunchClick,
  };

  // Sauvegarde du filtre actuel dans le localStorage
  useEffect(() => {
    localStorage.setItem("filter_lots", JSON.stringify(filter));
  }, [filter]);

  const sortedData = applySort(filteredData, sortField, sortOrder);

  return (
    <>
      <div className="page-container">
        <div className="table-responsive style_table_responsive">
          <table className="table table-striped" style={{ lineHeight: 1 }}>
            <thead className="style_thead">
              {renderHeaderRow(
                config,
                colorFilter,
                toggleDateFilterVisibility,
                t
              )}
            </thead>
            <tbody className="style_tbody">
              {renderFilterRow(config, context)}
              {sortedData.length === 0 ? (
                <tr>
                  <td
                    colSpan={config.length}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    {t("No data to display")}
                  </td>
                </tr>
              ) : (
                sortedData
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((item) =>
                    renderDataRow(item, config, {
                      ...context,
                      data,
                      setData,
                      configKey,
                      navigate,
                      modelInstanceStatuses,
                    })
                  )
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          filteredData={filteredData}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      {isDateFilterVisible && (
        <DateFilterModal
          dateRangeFilter={dateRangeFilter}
          setDateRangeFilter={setDateRangeFilter}
          onClose={toggleDateFilterVisibility}
        />
      )}

      {showModal && (
        <RelaunchInstance
          instanceData={selectedInstance}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default LotsTableComponent;
